import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

type ResetDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  resetFormAndClearTemplateId: () => void;
};

export function ResetTemplateDialog({
  open,
  onOpenChange,
  resetFormAndClearTemplateId,
}: ResetDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader className="flex flex-col gap-xs justify-start items-start">
          <DialogTitle>Reset Form?</DialogTitle>
          <DialogDescription>
            This will clear all your form data and start fresh. This action
            cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="secondary">Cancel</Button>
          </DialogClose>
          <Button variant="primary" onClick={resetFormAndClearTemplateId}>
            Reset Form
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
